var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "filter-type-switch feeds-filter-switch" }, [
    _c(
      "label",
      { class: { disabled: _setup.disabled } },
      [
        _c(
          "span",
          { staticClass: "name", class: { disabled: _setup.disabled } },
          [_vm._v(_vm._s(_vm.type.name))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _setup.disabled,
              expression: "disabled",
            },
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_setup.disabled)
              ? _vm._i(_setup.disabled, null) > -1
              : _setup.disabled,
          },
          on: {
            change: function ($event) {
              var $$a = _setup.disabled,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_setup.disabled = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_setup.disabled = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _setup.disabled = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _setup.disabled
          ? _c(_setup.VIcon, {
              staticClass: "disabled",
              attrs: { size: 16, icon: "mdi-cancel" },
            })
          : _c(_setup.VIcon, { attrs: { size: 16, icon: "mdi-check" } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }